module.exports = __webpack_public_path__ + "static/media/hraswo_sundar_su.3fcd63a7.ogg";